// From http://emailregex.com/
export const LOWERCASE_EMAIL_ADDRESS_REGEX =
  /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;
export const EMAIL_ADDRESS_REGEX = new RegExp(LOWERCASE_EMAIL_ADDRESS_REGEX.source, 'i');

// We support TLDs of 2-15 length, arbitrarily picked
export const FREE_EMAIL_PROVIDER_REGEX =
  /^([\w-.+]+@(?!gmail.com)(?!yahoo.com)(?!outlook.com)(?!aol.com)(?!icloud.com)(?!me.com)(?!hotmail.com)(?!mail.com)(?!protonmail.com)(?!proton.me)(?!incode.com)(?!comcast.net)(?!sbcglobal.net)(?!qq.com)([\w-]+\.)+[\w-]{2,15})?$/;
export const DOMAIN_LIST_MATCH_REGEX = /^[a-z0-9-.]+$/;

export const POSTAL_CODE_REGEX = /^\d{5}(-\d{4})?$/;
export const POSTAL_CODE_GB_REGEX = /^[A-Z]([A-Z]?\d[A-Z]|\d{1,2}|[A-Z]\d{1,2}) \d[A-Z][A-Z]$/i;

export const DOMAIN_REGEX =
  /(?:[a-z0-9*](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9](?:\/)?$/;
export const URI_SCHEME_REGEX = /^([A-Za-z])([A-Za-z0-9+.-])*$/;

export const EMPLOYER_IDENTIFICATION_NUMBER_REGEX = /^[1-9]\d?-\d{7}$/;

// Keep in sync with NAME_REGEXP in app/models/onboarding_flow_v1
export const NAME_REGEX = /^[a-zA-Z0-9\u00C0-\u017F.&:()[\]@',\-\s]+$/;
